// src/api/roles.api.ts — SCE Issues
// Le bloc `roles` de la ligne `__global__` de SCE_UserPrefs (panneau
// d'administration, 22/10). Comme les couleurs métier : lu une fois par
// session, chaque écriture RELIT la ligne et ne remplace que ce bloc.

import { lireBlocGlobal, modifierBlocGlobal } from './reglagesGlobaux.api'
import { rolesParDefaut } from '@/config/rolesDefaut'
import { CLE_BLOC_ROLES, lireRoles, type Roles } from '@/utils/roles'

/**
 * Les rôles enregistrés, complétés par les valeurs du code ; null si rien n'a
 * jamais été enregistré (l'appli garde alors les listes du code telles quelles).
 */
export async function lireRolesEnregistres(): Promise<Roles | null> {
  const brut = await lireBlocGlobal(CLE_BLOC_ROLES)
  return brut === undefined || brut === null ? null : lireRoles(brut, rolesParDefaut())
}

/**
 * Applique un changement aux rôles relus à l'instant (un autre administrateur a
 * pu écrire entre-temps) et renvoie ce qui a été écrit. Le bloc écrit est
 * COMPLET : les listes du code y sont recopiées au premier enregistrement, et
 * les flows lisent ainsi une liste entière.
 */
export async function modifierRoles(changer: (actuels: Roles) => Roles, par: string): Promise<Roles> {
  let ecrit: Roles = rolesParDefaut()
  await modifierBlocGlobal(CLE_BLOC_ROLES, (actuel) => {
    ecrit = changer(lireRoles(actuel, rolesParDefaut()))
    return { ...ecrit, modifie: { par, le: new Date().toISOString() } }
  })
  return ecrit
}
